module.exports = __webpack_public_path__ + "static/img/trpart2.bb4a1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trpart2.png
// module id = DQl1
// module chunks = 9